import { ScriptsLoader } from './src/ScriptsLoader';
import { StylesLoader } from "./src/StylesLoader";

export { ScriptsLoader, StylesLoader };